import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class WaterPotentialSensor extends Sensor {
  public preassureChart: any;
  public temperatureChart: any;

  private preassureSensor: any[];
  private temperatureSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.preassureChart = null;
    this.temperatureChart = null;

    this.preassureSensor = [[], [], []];
    this.temperatureSensor = [[], [], []];
  }

  public hasPressSensor(pos: number): boolean {
    return this.preassureSensor[pos - 1].length > 0;
  }

  public getPressSensor(pos: number): any {
    const realPos: number = this.preassureSensor[pos - 1].length - 1;
    return this.preassureSensor[pos - 1][realPos][1] ?? null;
  }

  public hasTemperatureSensor(pos: number): boolean {
    return this.temperatureSensor[pos - 1].length > 0;
  }

  public getTemperatureSensor(pos: number): any {
    const realPos: number = this.temperatureSensor[pos - 1].length - 1;
    return this.temperatureSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.preassureSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.preassure,
      ]);
      this.temperatureSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);
    }
  }

  public setCharts(): void {
    this.temperatureChart = this.getConfigChar(
      'wpTemp',
      this.getChartSeries('Temp', this.temperatureSensor),
      this.getRanges('5_temperature'),
      this.getLimits('5_temperature')
    );
    this.preassureChart = this.getConfigChar(
      'preassure2',
      this.getChartSeries('Pres', this.preassureSensor),
      this.getRanges('5_preassure'),
      this.getLimits('5_preassure')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura', value: '5_temperature' },
      { title: 'Tensión matricial', value: '5_preassure' }
    ];
  }
}